import { SUPPLY } from "./config";

const compact = new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 });
const usd2 = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 });

export function fmtUsd(v: number): string {
  if (!Number.isFinite(v)) return "—";
  if (Math.abs(v) >= 10_000) return "$" + compact.format(v);
  if (Math.abs(v) >= 1) return usd2.format(v);
  if (v === 0) return "$0";
  return "$" + v.toPrecision(3);
}

export function fmtEth(v: number, digits = 4): string {
  if (!Number.isFinite(v)) return "—";
  if (v === 0) return "0 ETH";
  if (Math.abs(v) >= 1) return `${v.toLocaleString("en-US", { maximumFractionDigits: 3 })} ETH`;
  if (Math.abs(v) >= 0.0001) return `${v.toFixed(digits).replace(/0+$/, "").replace(/\.$/, "")} ETH`;
  return `${v.toPrecision(2)} ETH`;
}

export function fmtNum(v: number): string {
  if (!Number.isFinite(v)) return "—";
  if (Math.abs(v) >= 10_000) return compact.format(v);
  return v.toLocaleString("en-US", { maximumFractionDigits: 2 });
}

export function fmtPct(v: number): string {
  if (!Number.isFinite(v)) return "—";
  return `${v >= 0 ? "+" : ""}${v.toFixed(Math.abs(v) >= 10 ? 0 : 1)}%`;
}

/** A per-token price in ETH expressed as the market cap it implies. */
export function priceToMcapUsd(priceEth: number, ethUsd: number): number {
  return priceEth * SUPPLY * ethUsd;
}

export function fmtMcap(priceEth: number, ethUsd: number): string {
  return fmtUsd(priceToMcapUsd(priceEth, ethUsd));
}

export function shortAddr(a?: string): string {
  return a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "";
}

export function fmtExpiry(ts: number): string {
  const d = new Date(ts * 1000);
  return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", timeZone: "UTC" }) + ", 20:00 UTC";
}

export function timeLeft(ts: number, now = Date.now() / 1000): string {
  let s = Math.max(0, Math.floor(ts - now));
  const d = Math.floor(s / 86400);
  s -= d * 86400;
  const h = Math.floor(s / 3600);
  s -= h * 3600;
  const m = Math.floor(s / 60);
  s -= m * 60;
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${String(s).padStart(2, "0")}s`;
  return `${s}s`;
}

export const wei = (v: string | bigint) => Number(BigInt(v)) / 1e18;
